import React from "react";
import Grid from '@mui/material/Grid';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import IconButton from '@mui/material/IconButton';
import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

export default function ToArchive() {

    return (
      <>
    
    <Grid container >
        <Tooltip title="DNA Archive" placement="bottom">
            <IconButton component={RouterLink} to="/DNAArchiveWelcome" >
                <LockOpenIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
            </IconButton>   
        </Tooltip>
    </Grid>
</>
)}